import { NoDataIllustration } from '@campx-org/shared'
import { Box, Typography, styled } from '@mui/material'
import { NoPartImage } from 'assets/images'

export const NoDataComponent = ({ message = 'No Data Found' }: { message?: string }) => {
  return (
    <>
      <StyledLogoContainer sx={{ width: '100%', height: '100vh' }}>
        <NoDataIllustration
          imageSrc={NoPartImage}
          message={
            <Typography
              variant="h6"
              style={{ textAlign: 'center', marginTop: '20px' }}
            >
              {message}
            </Typography>
          }
        />
      </StyledLogoContainer>
    </>
  )
}

export const StyledLogoContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
